import React, { useEffect, useState } from "react";
import { server } from "../../../common";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { useSelectAccess } from "../../../store/stateFunctions";
import Swal from "sweetalert2";
import { AiFillDelete } from "react-icons/ai";
import withReactContent from "sweetalert2-react-content";

const swalalert = withReactContent(Swal);

const IndustryEventEntries = () => {
  const user = useSelectAccess("Industry User");
  const [data, setData] = useState([]);

  useEffect(() => {
    getIndEventEnquiry();
  }, []);

  // Get
  const getIndEventEnquiry = () => {
    server
      .get("/event/orgeventapplications", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // Delete

  const deleteMerchantEnquiry = (data) => {
    console.log("data:", data);
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${data.shop_name} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/shopdetails/deleteenquiry/${data.id}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: user.authToken,
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire("Deleted!", "Blog has been deleted.", "success");
                getIndEventEnquiry();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };

  return (
    <div>
      <h3 className="text-center my-3">Event Registration Entries</h3>
      <div className=" row my-3">
        {/* <div className="col-md-4 text-end my-1">
          <select className="form-control text-uppercase" name="" id="">
            <option value="">Gyms</option>
            <option value="">Cafe's</option>
            <option value="">Lodge</option>
            <option value="">Bakery</option>
            <option value="">Classes</option>
            <option value="">Library</option>
            <option value="">Travels</option>
            <option value="">Laundry</option>
            <option value="">Garriage</option>
            <option value="">Medicals</option>
            <option value="">Restaurants</option>
            <option value="">Stationery</option>
            <option value="">Cyber Cafe</option>
            <option value="">Event Decors</option>
            <option value="">PG/Hostels</option>
            <option value="">Doctors/Clinic</option>
            <option value="">Salons/Parlours</option>
            <option value="">Mess/Parcel Points</option>
          </select>
        </div>
        <div className="col-md-4 text-start my-1"></div>
        <div className="col-md-4 text-start my-1">
          <input
            type="search"
            name=""
            id=""
            className="form-control"
            placeholder="Search"
          />
        </div> */}
      </div>
      <div className="container" style={{ overflow: "scroll" }}>
        <table className="table table-striped border">
          <thead>
            <tr>
              <th scope="col">Sr. No.</th>
              <th scope="col">Event Title</th>
              <th scope="col">Event Date</th>
              <th scope="col">Address</th>
              <th scope="col">Student Name</th>
              <th scope="col">Contact No.</th>
              <th scope="col">Gender</th>
              <th scope="col">Email Id</th>
              <th scope="col">Address</th>
              <th scope="col">Message</th>
              <th scope="col">Delete</th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data?.map((item, index) => {
                return (
                  <tr key={item.id}>
                    <th scope="row">{index + 1}</th>
                    <td>{item.title}</td>
                    <th>{item.event_date}</th>
                    <td>{item.address}</td>
                    <td>{item.name}</td>
                    <td>{item.contactno}</td>
                    <td>{item.gender}</td>
                    <td>{item.email}</td>
                    <td>{item.address}</td>
                    <td>{item.message}</td>

                    <td>
                      <div className="btn banner text-white">
                        <AiFillDelete
                          onClick={() => deleteMerchantEnquiry(item)}
                        />
                      </div>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default IndustryEventEntries;
